import { DataGrid } from '@mui/x-data-grid';
import { frFR as pickersFrFR } from '@mui/x-date-pickers-pro/locales';
import { frFR as datagridFrFR } from '@mui/x-data-grid-pro/locales';
import { frFR as coreFrFR } from '@mui/material/locale';

import QuicksandMedium from "../assets/fonts/quicksand/QuicksandMedium.woff2"
import QuicksandLight from "../assets/fonts/quicksand/QuicksandLight.woff2"
import QuicksandRegular from "../assets/fonts/quicksand/QuicksandRegular.woff2"
import QuicksandBold from "../assets/fonts/quicksand/QuicksandBold.woff2"

import LISAQUA_COLORS from "../const/Colors"

import { createTheme, CssBaseline, ThemeProvider } from "@mui/material";
import { useUserPreferencesStore } from "./store";
import { useMemo } from "react";
const lightTextShadow = { textShadow: '0px 1px 1px #ffffff45' }
const darkTextShadow = { textShadow: '0px 1px 1px #00000045' }

export const buildTheme = (positiveMode:boolean) => createTheme({
  //https://mui.com/material-ui/customization/css-theme-variables/configuration/#toggling-dark-mode-manually
  cssVariables: {
    colorSchemeSelector: 'class'
  },
  colorSchemes: {
    dark: {
      palette: {
        primary: {
          main: LISAQUA_COLORS.blue[600],
        },
        secondary: {
          main: LISAQUA_COLORS.blue[300],
        },
        success: {
          main: LISAQUA_COLORS.green[600],
        },
        background: {
          paper: LISAQUA_COLORS.dark[1000],
          default: LISAQUA_COLORS.dark[950],
        }
      }
    },
  },
  // mixins: {
  //   //@ts-expect-error https://mui.com/x/react-data-grid/style/#theme-header-and-pinned-sections
  //   "MuiDataGrid": {
  //     // Pinned columns sections
  //     pinnedBackground: LISAQUA_COLORS.dark[950] + " !important",

  //     // Headers, and top & bottom fixed rows
  //     // containerBackground: '#FFF', // Doesn't work
  //   },
  // },
  typography: {
    fontFamily: [
      'QuickSand',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    fontSize: 14,
    h1: {
      // ...lightTextShadow,
      fontSize: '2rem'
    },
    h2: {
      // ...lightTextShadow,
      fontSize: '1.4rem',
      // fontWeight: 'bold',
    },
    h3: {
      // ...lightTextShadow,
      fontSize: '1.3rem'
    },
    h4: {
      // ...lightTextShadow,
      fontSize: '1.25rem',
      fontWeight: 'bold'
    },
    h5: {
      // ...lightTextShadow,
      fontSize: '1.25rem',
    },
    h6: {
      // ...lightTextShadow,
      fontSize: '1.10rem',
      fontWeight: 'bold'
    },
    subtitle2: { color: '#828d94' },
  },

  components: {
    MuiFormLabel: {
      styleOverrides: {
        asterisk: {
          color: LISAQUA_COLORS.red[500]
        },
      },
    },
    MuiTableFooter: {
      styleOverrides: {
        root: {
          flexDirection: "row-reverse"
        }
      }
    },
    MuiTypography: {
      variants: [
        {
          props: { variant: 'h4' },
          style: {
            fontWeight: "bold"
          }
        },
        {
          props: { variant: 'h5' },
          style: {
            fontWeight: "bold"
          }
        },
        {
          props: { variant: 'h6' },
          style: {
            fontWeight: "bold"
          }
        },
        {
          props: { variant: 'caption' },
          style: {
            textTransform: 'uppercase',
            color: '#64676D'
          },
        }
      ]
    },
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'QuickSand';
          src: local('Quicksand Medium'), local('Quicksand-Medium'), url(${QuicksandMedium}) format('woff2');
          font-weight: 500;
          font-style: normal;
            font-display: swap;
        }
        
        @font-face {
            font-family: 'QuickSand';
            src: local('Quicksand Light'), local('Quicksand-Light'), url(${QuicksandLight}) format('woff2');
            font-weight: 300;
            font-style: normal;
            font-display: swap;
        }
        
        @font-face {
            font-family: 'QuickSand';
            src: local('Quicksand Regular'), local('Quicksand-Regular'), url(${QuicksandRegular}) format('woff2');
            font-weight: normal;
            font-style: normal;
            font-display: swap;
        }
        
        @font-face {
            font-family: 'QuickSand';
            src: local('Quicksand Bold'), local('Quicksand-Bold'), url(${QuicksandBold}) format('woff2');
            font-weight: bold;
            font-style: normal;
            font-display: swap;
        }
        
      `,
    },

  },
  palette: {
    primary: {
      ...LISAQUA_COLORS.blue,
      main: LISAQUA_COLORS.blue[500],
    },
    success: {
      ...LISAQUA_COLORS.green,
      main: LISAQUA_COLORS.green[600],
    },
    error: {
      ...(positiveMode ? LISAQUA_COLORS["blue-lisaqua"] : LISAQUA_COLORS.red),
      main: (positiveMode ? LISAQUA_COLORS["blue-lisaqua"][500] : LISAQUA_COLORS.red[500]),
    },
    warning: {
      ...(positiveMode ? LISAQUA_COLORS["blue-2-lisaqua"] : LISAQUA_COLORS.orange),
      main: (positiveMode ? LISAQUA_COLORS["blue-2-lisaqua"][500] : LISAQUA_COLORS.orange[500]),
    },
    secondary: {
      ...LISAQUA_COLORS.blue,
      main: LISAQUA_COLORS.blue[900],
    },
    background: {
      paper: "#ffffff"
    }
  },
},
  // frFR, // x-data-grid translations
  pickersFrFR, // x-date-pickers translations
  coreFrFR, // core translations
  datagridFrFR, // core translations
);

const ThemeProviderLisaqua = (props) => {
  const positiveMode = useUserPreferencesStore((s) => s.positiveMode)
  const theme = useMemo(() => buildTheme(positiveMode), [positiveMode])

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {props.children}
    </ThemeProvider>
  )
}
export default ThemeProviderLisaqua